import { useEffect, useMemo, useRef, useCallback } from "react";
import NewPlacement from "../../Modals/NewPlacement";
import PlacementDataStore from "../../../Flux/Stores/PlacementDataStore";

import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import Modal from "@acadia-ui/modal";
import { retryAtInterval } from "./retryAtInterval";

export default function useNewPlacement({ config, campaignMetaData, updateCounts, updateMetaData, auditLevelData, auditLevelID, refresh }) {
	const newPlacementModal = useRef(null);
	const persistenceRef = useRef({});

	useEffect(() => {
		const parentPackageCreated = () => {
			retryAtInterval(
				() => {
					newPlacementModal.current.parentChanged();
					if (!newPlacementModal.current.state.open) {
						newPlacementModal.current.openModal();
					}
				},
				() => {
					return newPlacementModal.current.state.open;
				},
				500
			);
		};

		const openModal = () => {
			retryAtInterval(
				() => {
					if (persistenceRef?.current?.keepModalOpen) {
						if (!newPlacementModal?.current?.state?.open) {
							if (persistenceRef?.current?.value?.value === "Search Order") {
								// If the 'parent' is Search Order, we repopulate the previously selected fields
								newPlacementModal?.current?.handleSearchOrder(persistenceRef?.current?.prepopulatedData);
							}
							// If the 'parent' is Standalone, we repopulate the previously selected fields
							newPlacementModal?.current?.openModal(persistenceRef?.current?.prepopulatedData);
						}
					}
				},
				() => {
					const result = newPlacementModal?.current?.state?.open || !persistenceRef?.current?.keepModalOpen;
					if (newPlacementModal?.current?.state?.open && persistenceRef?.current?.keepModalOpen) {
						persistenceRef.current = {};
					}
					return result;
				},
				1000
			);
		};

		PlacementDataStore.on("openPlacementModal", parentPackageCreated);
		PlacementDataStore.on("placements_loaded", openModal);

		return () => {
			PlacementDataStore.removeListener("openPlacementModal", parentPackageCreated);
			PlacementDataStore.removeListener("placements_loaded", openModal);
		};
	}, []);

	const DisplayedComponent = useCallback(() => {
		return (
			<NewPlacement
				newPlacement={(ref) => {
					newPlacementModal.current = ref;
				}}
				config={config}
				metaData={campaignMetaData}
				updateCounts={updateCounts}
				updateMetaData={updateMetaData}
				auditLevelData={auditLevelData}
				auditLevelID={auditLevelID}
				refresh={async (keepModalOpen, value) => {
					const prepopulatedData = {
						formData: newPlacementModal.current.state.formData,
						postData: newPlacementModal.current.state.postData,
						valueToCalculate: newPlacementModal.current.state.valueToCalculate,
						packageData: newPlacementModal.current.state.packageData
					};

					persistenceRef.current = { keepModalOpen, value, prepopulatedData };

					// await refresh();

					// if (keepModalOpen) {
					// 	retryAtInterval(
					// 		() => {
					// 			if (!newPlacementModal.current.state.open) {
					// 				if (value?.value === "Search Order") {
					// 					// If the 'parent' is Search Order, we repopulate the previously selected fields
					// 					newPlacementModal.current.handleSearchOrder(prepopulatedData);
					// 				}
					// 				// If the 'parent' is Standalone, we repopulate the previously selected fields
					// 				newPlacementModal.current.openModal(prepopulatedData);
					// 			}
					// 		},
					// 		() => {
					// 			return newPlacementModal.current.state.open;
					// 		},
					// 		500
					// 	);
					// }
				}}
			/>
		);
	}, [config, campaignMetaData, updateCounts, updateMetaData, auditLevelData, auditLevelID]);

	const Trigger = useCallback(() => {
		return (
			<Button
				style={{ order: 3 }}
				key="add-placement"
				size={BUTTON_SIZE.SMALL}
				onClick={() => {
					newPlacementModal.current.triggerOpenClose();
				}}
				data-tracking-id-alt="open-add-placement-modal"
			>
				Add Placement
			</Button>
		);
	}, []);

	return useMemo(() => [Trigger, DisplayedComponent], [Trigger, DisplayedComponent]);
}
